/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spaces[3],
    paddingVertical: theme.spaces[2]
  },
  addressContainer: {
    borderWidth: 1,
    borderColor: '#F7F7F7',
    borderRadius: theme.radius.md,
    fontWeight: theme.textWeights.bold
  },
  iconContainer: {
    borderWidth: 1,
    borderColor: theme.textColors.forth,
    height: 40,
    width: 40
  },
  addressDesc: {
    ...theme.textSizes.xs,
    color: theme.textColors.secondary
  },
  // 内容区域
  contentContainer: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderRadius: theme.radius.md,
    ...TwTheme.values.shadows.card,
    padding: theme.spaces[3]
  },
  contentHeader: {
    justifyContent: 'space-between'
  },
  headerTitle: {
    ...theme.textSizes.xs,
    color: theme.textColors.base
  },
  headerButton: {
    ...theme.textSizes.xs, //16
    color: theme.primaryColors.base
  },
  //内容footer区域
  contentFooter: {
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  //内容footer区域字体的样式设置
  commodityNumber: {
    ...theme.textSizes.xs,
    color: theme.textColors.secondary
  },
  priceTitle: {
    ...theme.textSizes.sm, //16
    color: theme.textColors.base
  },
  priceSymbol: {
    ...theme.textSizes.xs, //16
    color: theme.textColors.base,
    marginRight: 2
  },
  price: {
    ...theme.textSizes.md, //16
    color: theme.textColors.base,
    fontWeight: theme.textWeights.bold
  },

  // footer 区域按钮
  commandContainer: {
    backgroundColor: '#ffffff',
    padding: theme.spaces[4]
  },
  button: {
    flex: 1,
    borderRadius: 28,
    paddingHorizontal: theme.spaces[3],
    paddingVertical: theme.spaces[2]
  },
  contentDesc: {
    ...theme.textSizes.xs,
    color: theme.textColors.secondary
  }
});
